
import bossCloud from '../utils/bossCloud'

// 白条订单列表
export function financeShopping_list(data) {
  return bossCloud({ url: 'mall/api/financeShopping/list', method: 'post', data })
}
// 白条订单详情
export function financeShopping_detail(data) {
  return bossCloud({ url: 'mall/api/financeShopping/detail', method: 'post', data })
}
// 白条订单退款列表
export function financeShopping_refundList(data) {
  return bossCloud({ url: 'mall/api/financeShopping/refundList', method: 'post', data })
}
